angular.module('core')
    .directive('ngIncludeReplace', function() {
        return {
            require: 'ngInclude',
            link: function(scope, element, attrs) {
                element.replaceWith(element.children());
            }
        };
    });